import { memo } from 'react';

import { Heading, Text } from '@/components/core';

import { BillingDetails } from './BillingDetails.tsx';
import { Page } from './Page';
import { WorkspaceHeader } from './WorkspaceHeader.tsx';

export type BillingProps = object;

// eslint-disable-next-line no-empty-pattern
const IBilling = ({}: BillingProps) => {
  return (
    <Page className="w-[40rem]">
      <WorkspaceHeader>
        <Heading>Billing</Heading>
        <Text>Update your payment information or switch plans according to your needs</Text>
      </WorkspaceHeader>

      <BillingDetails />
    </Page>
  );
};

export const Billing = memo(IBilling) as typeof IBilling;
